"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _EventTimesModule = _interopRequireDefault(require("./EventTimes.module.css"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone/moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EventTimes = /*#__PURE__*/function (_React$Component) {
  _inherits(EventTimes, _React$Component);

  var _super = _createSuper(EventTimes);

  function EventTimes(props) {
    var _this;

    _classCallCheck(this, EventTimes);

    _this = _super.call(this, props);
    _this.state = {
      m: (0, _momentTimezone["default"])(_this.props.start * 1000),
      mEnd: (0, _momentTimezone["default"])(_this.props.end * 1000),
      time: "".concat((0, _momentTimezone["default"])(_this.props.start * 1000).tz(_this.props.timezone).format("MMMM Do"), " \u2022 ").concat((0, _momentTimezone["default"])(_this.props.start * 1000).tz(_this.props.timezone).format("h:mm A"), " - ").concat((0, _momentTimezone["default"])(_this.props.end * 1000).tz(_this.props.timezone).format("h:mm A z"))
    };
    return _this;
  }

  _createClass(EventTimes, [{
    key: "render",
    value: function render() {
      var font = "9px";

      if (window.innerWidth >= 768 && window.innerWidth <= 1149 || window.innerWidth < 470) {
        font = "7px";
      }

      if (this.props.live) {
        if (this.props.type === "large") {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].time_large,
            style: {
              fontSize: font
            }
          }, "JOIN US LIVE THROUGH ", this.state.mEnd.tz(this.props.timezone).format("h:mm A z")));
        } else if (this.props.type === "top") {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].time_top,
            style: {
              fontSize: font
            }
          }, "JOIN US LIVE THROUGH ", this.state.mEnd.tz(this.props.timezone).format("h:mm A z")));
        } else {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].outer_div_live
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].day
          }, this.state.m.tz(this.props.timezone).format("ddd").toUpperCase()), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].date
          }, this.state.m.tz(this.props.timezone).format("D")), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].vert1
          }), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].vert2
          }), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].horizontal
          })), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].time,
            style: {
              fontSize: font
            }
          }, "Also join us live through ", this.state.mEnd.format("h:mm A z")));
        }
      } else {
        if (this.props.type === "past") {
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].past_shadow
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].outer_div_past
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].day
          }, this.state.m.tz(this.props.timezone).format("ddd").toUpperCase()), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].date
          }, this.state.m.tz(this.props.timezone).format("D")), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].vert1
          }), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].vert2
          }), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].horizontal
          })), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].time_past,
            style: {
              fontSize: font
            }
          }, this.state.time));
        } else {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].outer_div,
            styles: {
              background: "#273243"
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].day
          }, this.state.m.tz(this.props.timezone).format("ddd").toUpperCase()), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].date
          }, this.state.m.tz(this.props.timezone).format("D")), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].vert1
          }), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].vert2
          }), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].horizontal
          })), /*#__PURE__*/_react["default"].createElement("div", {
            id: _EventTimesModule["default"].time,
            style: {
              fontSize: font
            }
          }, this.state.time));
        }
      }
    }
  }]);

  return EventTimes;
}(_react["default"].Component);

var _default = EventTimes;
exports["default"] = _default;

//# sourceMappingURL=EventTimes.js.map